import React from 'react';

function Review(props) {
  const { name, cocktail, rating, comment } = props.review;

  return (
    <div className="review">
      <p className="review-text">{name} - {cocktail}</p>
      <p className="review-text">Rating: {rating}</p>
      <p className="review-text">{comment}</p>
    </div>
  );
}

function ReviewsList(props) {
  const { reviews } = props;

  return (
    <div className="reviews-list">
      {reviews.map(review => (
        <Review key={review.id} review={review} />
      ))}
    </div>
  );
}

export default ReviewsList;
